export default function CrossActionIcon() {
  return (
    <>
      <svg
        width="33"
        height="32"
        viewBox="0 0 33 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="1.07178"
          y="0.5"
          width="31"
          height="31"
          rx="15.5"
          fill="white"
        />
        <rect
          x="1.07178"
          y="0.5"
          width="31"
          height="31"
          rx="15.5"
          stroke="#FFA19B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0415 21.4688L22.0415 9.46875L23.1022 10.5294L11.1022 22.5294L10.0415 21.4688Z"
          fill="#FF3838"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.1021 21.4688L11.1021 9.46875L10.0414 10.5294L22.0414 22.5294L23.1021 21.4688Z"
          fill="#FF3838"
        />
      </svg>
    </>
  );
}
